import React, { FC, HTMLAttributes, RefObject, PropsWithChildren } from 'react';

import type { ComponentImage } from '../../types/generics';
import decorate from '../decorate/decorate';

export interface ImageProps extends ComponentImage, HTMLAttributes<HTMLImageElement> {
  /** Allows the component to get additional styles. */
  className?: string;
  /** Image height */
  height?: string | number;
  /** Checks if the image should be a background image. */
  isBackgroundImage?: boolean;
  /** Checks if the position of the image is on the left of content and applies styles. */
  isLeft?: boolean;
  /** Changes how the image is loaded on the page. */
  loading?: 'eager' | 'lazy';
  onLoad?: (e: any) => void;
  /** The title for the Image. */
  title?: string;
  ref?: RefObject<HTMLImageElement>;
  /** Image width */
  width?: string | number;
}

const ImageComponent: FC<PropsWithChildren<ImageProps>> = ({
  className,
  height,
  width,
  imageAlt,
  imageSrc,
  loading = 'eager',
  title,
  onLoad,
  ref,
  ...rest
}) => (
  <img
    {...rest}
    ref={ref}
    alt={imageAlt}
    css={{
      label: 'imageContainer',
    }}
    // eslint-disable-next-line react/jsx-sort-props
    className={className}
    height={height}
    loading={loading}
    onLoad={onLoad}
    src={imageSrc}
    title={title}
    width={width}
  />
);

// manually adding display name or it goes missing on build
ImageComponent.displayName = 'Image';
const Image = decorate<ImageProps>(ImageComponent);

export { Image };
export default Image;
